import * as z from "zod";
import { listFetchErrorKey, listFetchStateKey } from "../connectors/listRows";
import { mutator } from "./mutator";

export const refreshConnectorListSchema = z.object({
  connectedAppId: z.string(),
  prefix: z.string(),
});

export const refreshConnectorList = mutator({
  schema: refreshConnectorListSchema,
  resolve: {
    app: { kind: "connectedApp", from: "connectedAppId" },
  },
  permissions: [
    {
      permission: "connected_app:write",
      scopeId: ({ args }) => args.app.id,
    },
  ],
  fn: async ({ tx, args: { app, prefix } }) => {
    await tx.mutate.connectedApps.update({
      id: app.id,
      configuration: {
        ...app.configuration,
        [listFetchStateKey(prefix)]: "fetching",
        [listFetchErrorKey(prefix)]: "",
      },
    });
  },
});
